var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-header"},[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_c('logo')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }